<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="voie?.num" 
 
[label]="step12.getnum"
[type]="'text'" [rule]="'minSize_1|maxSize_50'"
[errorMessage]="errorMessage"
[name]="getUid()+'_SepAtt_num'">
</app-form-input>

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="voie?.typevoie" 
[errorMessage]="errorMessage"
[label]="step12.gettypevoie"
[type]="'text'" [rule]="'minSize_1|maxSize_255'"
[name]="getUid()+'_SepAtt_typevoie'">
</app-form-input>

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="voie?.nomvoie" 
[errorMessage]="errorMessage"
[label]="step12.getnomvoie"
[type]="'text'" [rule]="'minSize_5|maxSize_1000'"
[name]="getUid()+'_SepAtt_nomvoie'">
</app-form-input>